export const visit = (vm, at) => {
at({ "fi": { "conversationsVisitorUIAvailability": { "sameDay": "Palaamme t\xE4n\xE4\xE4n {{time}}", "nextDay": "Palaamme huomenna {{time}}", "nextWeek": "Palaamme {{dayOfWeek}} {{time}}" } } });
};